export default __webpack_public_path__ + "static/01-13b5388d5ce5729d5803c398203be2a4.mp4";